module.exports = __webpack_public_path__ + "img/saimage3.81befaac.jpg";